/**
 * Undo the server's nested-array wrapping: Firestore stores no array inside an
 * array, so `publishTvState` writes each inner array as { __tvArray: [...] }
 * (functions/src/handlers/tvDisplay.ts, TV_NESTED_ARRAY_KEY).
 */
export function unwrapNestedArrays(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(unwrapNestedArrays);
  // Only plain objects: class instances (Firestore Timestamps) pass through.
  if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    const record = value as Record<string, unknown>;
    const keys = Object.keys(record);
    if (keys.length === 1 && keys[0] === '__tvArray' && Array.isArray(record.__tvArray)) {
      return (record.__tvArray as unknown[]).map(unwrapNestedArrays);
    }
    const out: Record<string, unknown> = {};
    for (const key of keys) out[key] = unwrapNestedArrays(record[key]);
    return out;
  }
  return value;
}
